// extracted by css-extract-rspack-plugin
export default {"legend":"yj0a3tG04lmTfKx6","icon":"YnHQ1qR7rwkb3np3"};